import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class PhoneVerificationError extends CodedError {
  static get errorName() {
    return errorCodes.phoneVerificationError.code;
  }

  constructor(message: string = errorCodes.phoneVerificationError.message) {
    super(message);
    this.code = errorCodes.phoneVerificationError.code;
    this.message = `${message} ${errorCodes.phoneVerificationError.code}`;
    this.name = errorCodes.phoneVerificationError.name;
  }
}
